import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ActionState } from 'src/app/enums/action-state.enum';
import { CoreEnum } from 'src/app/enums/core.enum';
import { MainRoute } from 'src/app/models/MainRoute';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { AlertService } from 'src/app/services';
import { RoutingService } from 'src/app/services/Routing.service';
import { StationService } from 'src/app/services/station.service';
import { AlertParameters, AlertType } from 'src/app/shared/models/models-index';
import { CreateStationSteps } from 'src/app/shared/models/station/create-station-steps';
import { ExendedOpcuaConfig } from 'src/app/shared/models/station/extended-opcua-config';
import { ApplicationFeature, OpcuaConfig, OpcuaConfigList } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-configuration-station-list',
    templateUrl: './configuration-station-list.component.html',
    styleUrls: ['./configuration-station-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfigurationStationListComponent implements OnInit {
  @Input() creationView: boolean;

  FEATURE = ApplicationFeature;
  loadingOpcuaState = new BehaviorSubject(ActionState.LOADING);
  actionState = ActionState;
  station: any;
  eUid: string;
  eType: string;
  opcuaConfigList: OpcuaConfig[] = [];
  successMessageOpcua: string;
  stationRoute: MainRoute = RoutingService.getStationRoute();

  constructor(
    private stationsRepo: StationsRepo,
    private translate: TranslateService,
    private alertService: AlertService,
    private router: Router,
    private stationService: StationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.station = JSON.parse(sessionStorage.getItem(CoreEnum.STATION_DETAIL));
    if (this.station) {
      this.eUid = this.station.uid;
    } else {
      this.route.params.subscribe((params: CreateStationSteps) => {
        if (params.uid) {
          this.eUid = params.uid;
          this.station = {
            uid: this.eUid,
          };
        }
        if (params.code) {
          this.station.code = params.code;
        }
      });
    }

    this.getExistedConfigurationOpcua();
  }

  getExistedConfigurationOpcua() {
    this.stationsRepo.listOpcuaConfigurations(this.eUid).subscribe({
      next: (res: OpcuaConfigList) => {
        this.loadingOpcuaState.next(ActionState.READY);
        this.opcuaConfigList = res.list;
        if (this.opcuaConfigList.length === 0) {
          this.addOpcuaConfig();
        }
      },
      error: (error) => {
        this.loadingOpcuaState.next(ActionState.READY);
        this.showAlert(error);
      },
    });
  }

  reloadConfigOpcua(event: any) {
    this.getExistedConfigurationOpcua();
    this.successMessageOpcua = event;
    setTimeout(() => {
      this.successMessageOpcua = null;
    }, 3000);
  }

  addOpcuaConfig(target?: HTMLElement) {
    const config: ExendedOpcuaConfig = { newConnection: true };
    this.opcuaConfigList.push(config);
    if (target && this.opcuaConfigList.length > 2) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }

  backToStep1() {
    const params: CreateStationSteps = {
      step: '1',
      uid: this.eUid,
    };
    this.router.navigate([this.stationRoute.path + '/create', params]);
  }

  goToCreatedStation() {
    this.router.navigateByUrl(`stations/${this.eUid}`);
  }

  showAlert(error: any) {
    const title = this.translate.instant('error.title');
    const alertParams = new AlertParameters(
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      title
    );
    this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  }
}
